<template>
  <page-view title="专家入库审核详情">
    <template slot="action" class="action">
      <a-button v-show="user.roles['system.manage']" @click="onEdit" icon="edit">编辑</a-button>
      <a-popconfirm placement="bottom" title="是否确认删除?" @confirm="onDel">
        <a-button :loading="delLoading" type="danger" icon="delete"
                  v-show="user.roles['system.manage']">删除
        </a-button>
      </a-popconfirm>
    </template>
    <a-card>
      <expertView-table :info="info" @success="loadData"/>
    </a-card>
    <workflow-comment v-if="ifWF && ifWF == '1'" :xwfState="xwfState" :is-expert="true"/>
  </page-view>
</template>

<script>
import qs from 'qs'
import { PageView } from '@/layouts'

import WorkflowMenu from '@/components/workflow/WorkflowMenu'
import WorkflowComment from '@/components/workflow/WorkflowComment'

import expertViewTable from '@/epp/expertmain/expertInfo/common/ExpertViewTable.vue'
import { DeleteExpertInfo, GetExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'ExpertView',
  components: {
    PageView,
    WorkflowMenu,
    WorkflowComment,
    expertViewTable
  },
  inject: ['reload'],
  data () {
    return {
      id: this.$route.query.id,
      ifWF: this.$route.query.ifWF,
      caseTypeId: '',
      user: this.$ls.get('user'),
      xwfState: {},
      info: {
        extras: {}
      },
      delLoading: false
    }
  },
  created () {
    this.loadData()
  },
  computed: {},
  methods: {
    onLoadXWFState (xwfState) {
      this.xwfState = xwfState
      this.caseTypeId = xwfState.caseTypeId
    },
    onWFBeforeNext () { // 流程点下一步
      // 进行业务逻辑判断，如判断必需的内容是否已填写
      // if (this.xwfState.hasEvtSignOut) {//判断会议记录是否有填写
      //   if(this.$refs.meetingRef.resultSize===0){
      //     if (!confirm("会议安排还未填写，是否确定执行下一步操作？")) {
      //       return false
      //     }
      //   }
      // }
      return true
    },
    async loadData () {
      const res = await GetExpertInfo(this.id)
      this.info = res.result
    },
    onEdit () {
      this.$router.push({ path: `/expertInfo/expertEdit?id=${this.id}&caseTypeId=${this.caseTypeId}` })
    },
    // 删除处理
    async onDel () {
      this.delLoading = true
      const res = await DeleteExpertInfo(this.id)
      this.delLoading = false
      if (res.code !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
</style>
